"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import SwiperCore from "swiper";
import Image from "next/image";

SwiperCore.use([Autoplay]);

const vipData = [
	{
		name: "John Oamen",
		img: "https://dv2fsdn0a7gra.cloudfront.net/584bcd84-944b-4d20-a30d-b95de2006737/founders/9d06f649-1c5a-47d9-bc6e-38d3e7513209.jpeg",
		company: "CutStruct Technology",
	},
	{
		name: "Heather Elias",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/94527ebf-5b18-4252-a8d5-c46bb64b2bc7.jpg",
		company: "Pearl Certification",
	},
	{
		name: "Gilbert Nakiboli",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/d306d6ab-58b0-4709-a300-6c76e12b8c24.jpeg",
		company: "Nakibolis Heirs Limited",
	},
	{
		name: "Shajai Jacob",
		img: "https://dv2fsdn0a7gra.cloudfront.net/anacity/founders/sdjvnkekvvsss.jpg",
		company: "ApnaComplex & ANACITY",
	},
	{
		name: "Christian Hendriksen",
		img: "https://dv2fsdn0a7gra.cloudfront.net/3872838c-0fe8-45b4-9fde-716e5d0d92c1/founders/efaf326e-7632-4108-855d-30238e00deee.jpeg",
		company: "Rensair",
	},
	{
		name: "Ejide Akinbiyi",
		img: "https://dv2fsdn0a7gra.cloudfront.net/e7d6b7c1-0c47-4ed2-8371-7d1b5e052bcc/founders/456eff8f-df76-4c10-bee0-7403ae040dd0.jpeg",
		company: "January 2024",
	},
	{
		name: "Aaron Short",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/47edf391-316d-4591-88b9-558238709009.jpg",
		company: "B-Line",
	},
	{
		name: "Anand Narayanan",
		img: "https://dv2fsdn0a7gra.cloudfront.net/alt-drx/founders/bhpyolciugtupjmj.jpeg",
		company: "Alt DRX",
	},
	{
		name: "Alan Fenn",
		img: "https://dv2fsdn0a7gra.cloudfront.net/6206ae69-e44a-4265-96f5-f3438331bf3a/founders/d68d907e-fcfc-4c24-94a8-c6fd8f51ae68.jpeg",
		company: "MLS Offers",
	},
	{
		name: "Richard Swerdlow",
		img: "https://dv2fsdn0a7gra.cloudfront.net/building-advisor/founders/gzranrnfjsjtdznu.jpeg",
		company: "Condo.com",
	},
	{
		name: "Giri Devanur",
		img: "https://dv2fsdn0a7gra.cloudfront.net/8f9b18a4-2537-4bfc-9965-507dd3c4db1c/founders/giri.png",
		company: "ReAlpha",
	},
	{
		name: "Kevin Greene",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/8af66e15-b03e-411a-b84d-a395dc7fa561.jpg",
		company: "Corelogic",
	},
	{
		name: "Vivek Agarwal",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/e2418050-7102-451c-90e0-96a5654d8624.jpg",
		company: "January 2024",
	},
	{
		name: "Nirupa Shankar",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/e3ae00e4-6a1c-4540-b3ef-0e3a7062ef24.jpg",
		company: "Brigade Group",
	},
	{
		name: "Rajeev Chhabra",
		img: "https://dv2fsdn0a7gra.cloudfront.net/9bf3d54d-f3b9-430c-81c4-d8b909d13b85/founders/34fe8cae-97fd-400d-96bb-1ecc4a712bcd.png",
		company: "PropFTX",
	},
	{
		name: "David Rajakovich",
		img: "https://dv2fsdn0a7gra.cloudfront.net/rekreate/founders/xkjirmqtoemjshxc.jpeg",
		company: "ReKreate",
	},
	{
		name: "Tharun Kumar",
		img: "https://dv2fsdn0a7gra.cloudfront.net/ecostp/founders/khzkyelsadxgshom.jpeg",
		company: "ECOSTP Technologies",
	},
	{
		name: "Stephen Nickel",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/bc0a88d0-0ac6-4875-b3c4-4b3d66d2406c.jpeg",
		company: "Hello Here SL",
	},
	{
		name: "Christian Papst",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/fa420d58-9d50-4a5a-b822-41f7c759409a.png",
		company: "vacancyPro",
	},
	{
		name: "Garima Bharadwaj",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/e57083d9-433f-4c94-8f4c-0ed0f84694f9.jpeg",
		company: "Enlite",
	},
	{
		name: "Shubhankar Dongre",
		img: "https://dv2fsdn0a7gra.cloudfront.net/profile-pictures/b34b6348-f902-4786-aeee-082e3b74a6a6.jpeg",
		company: "Zapkey & Propstack",
	},
];

export default function VIPArea() {
	return (
		<section className="pt-52 md:pt-60 lg:pt-72 xl:pt-80">
			{/* brands start */}
			<div>
				<div className="container xl:max-w-[1236px]">
					<div className="relative mb-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-4 pb-5 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-[radial-gradient(50%_50%_at_50%_50%,rgba(48,64,77,0.30)_0%,rgba(48,64,77,0.00)_100%)] sm:flex-nowrap sm:gap-8 lg:gap-16 xl:gap-24">
						<a rel="noopener" href="https://www.proptechbuzz.com" target="_blank">
							<Image
								src="/marketing/assets/img/brands/realpha.svg"
								alt="ReAlpha"
								width={144}
								height={31}
							/>
						</a>
						<a
							rel="noopener"
							href="https://www.proptechbuzz.com/products/ask-the-agent"
							target="_blank"
						>
							<Image
								src="/marketing/assets/img/brands/ask-the-agent.svg"
								alt="Ask the agent"
								width={144}
								height={53}
							/>
						</a>
						<a
							rel="noopener"
							href="https://www.proptechbuzz.com/products/hello-data-ai"
							target="_blank"
						>
							<Image
								src="/marketing/assets/img/brands/hello-data.svg"
								alt="Hello Data"
								width={144}
								height={39}
							/>
						</a>
						<a rel="noopener" href="https://www.proptechbuzz.com" target="_blank">
							<Image
								src="/marketing/assets/img/brands/inncircles-arena.svg"
								alt="InnCircles Arena"
								width={106}
								height={57}
							/>
						</a>
						<a
							rel="noopener"
							href="https://www.proptechbuzz.com/products/redistribute"
							target="_blank"
						>
							<Image
								src="/marketing/assets/img/brands/redistribute.svg"
								alt="Redistribute"
								width={164}
								height={87}
							/>
						</a>
					</div>
				</div>
			</div>
			{/* brands end */}
			{/* vip slider start */}
			<div>
				<h5 className="text-primary-600 text-center text-sm font-semibold">Our Premium VIPs</h5>
				<div className="overflow-hidden pb-16 pt-5 md:pb-24 xl:pb-32">
					<Swiper
						className="vip-slider-1"
						spaceBetween={20}
						centeredSlides={true}
						speed={6000}
						autoplay={{ delay: 1 }}
						loop={true}
						slidesPerView={"auto"}
						allowTouchMove={false}
						// disableOnInteraction={true}
					>
						{vipData.slice(0, vipData.length / 2).map((vip, index) => (
							<SwiperSlide key={index} className="!w-[264px]">
								<div className="flex items-center gap-3.5 rounded-lg p-4">
									<Image
										src={vip.img}
										alt={vip.name}
										className="h-14 w-14 shrink-0 rounded-full object-cover"
									/>
									<div className="shrink-0 rounded-lg bg-gray-100 px-3 py-2">
										<div className="flex items-center gap-1">
											<h4 className="font-semibold text-gray-900">{vip.name}</h4>
											<Image
												src="/marketing/assets/img/icon/verified-tick.svg"
												alt="verified tick"
											/>
										</div>
										<div className="flex items-center gap-1">
											<Image
												src="/marketing/assets/img/icon/brightness-plus.svg"
												alt="brightness-plus"
											/>
											<h5 className="text-primary-700 text-xs font-semibold">{vip.company}</h5>
										</div>
									</div>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
					<Swiper
						className="vip-slider-2"
						spaceBetween={20}
						centeredSlides={true}
						speed={6000}
						autoplay={{ delay: 1 }}
						loop={true}
						slidesPerView={"auto"}
						allowTouchMove={false}
						// disableOnInteraction={true}
						dir="rtl"
					>
						{vipData.slice(vipData.length / 2, vipData.length).map((vip, index) => (
							<SwiperSlide key={index} className="!w-[264px]">
								<div className="flex flex-row-reverse items-center gap-3.5 rounded-lg  p-4 ">
									<Image
										src={vip.img}
										alt={vip.name}
										className="h-14 w-14 shrink-0 rounded-full object-cover"
									/>
									<div className="shrink-0 rounded-lg bg-gray-100 px-3 py-2">
										<div className="flex flex-row-reverse items-center gap-1">
											<h4 className="font-semibold text-gray-900">{vip.name}</h4>
											<Image
												src="/marketing/assets/img/icon/verified-tick.svg"
												alt="verified tick"
											/>
										</div>
										<div className="flex flex-row-reverse items-center gap-1">
											<Image
												src="/marketing/assets/img/icon/brightness-plus.svg"
												alt="brightness-plus"
											/>
											<h5 className="text-primary-700 text-xs font-semibold">{vip.company}</h5>
										</div>
									</div>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</div>
			{/* vip slider end */}
		</section>
	);
}
